import React, { Component } from "react";
import _ from "lodash";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import gql from "graphql-tag";
import { Query } from "react-apollo";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setAvailablePeriods } from "../data/ducks";

const indicatorsQuery = gql`
	query {
		allIndicators {
			id
			name
			description
			paletteType
			generalities {
				description
				files {
					name
					Location
				}
			}
			inequalities {
				description
				files {
					name
					Location
				}
			}
			stratifiers {
				id
				name
				order
			}
			constant
		}
	}
`;

const indicatorsByTagQuery = gql`
	query allindicatorsByTag($tag: ID!) {
		allindicatorsByTag(tag: $tag) {
			id
			name
			description
			paletteType
			generalities {
				description
				files {
					name
					Location
				}
			}
			inequalities {
				description
				files {
					name
					Location
				}
			}
			stratifiers {
				id
				name
				order
			}
			constant
		}
	}
`;

class SelectDisease extends Component {
	state = {
		loaded: false
	};

	handleChangeIndicator(key, diseaseId) {
		const { setAvailablePeriods, handleChange } = this.props;
		setAvailablePeriods([]);
		handleChange(key, diseaseId);
	}

	render() {
		const { value, handleLoad, storeIndicators, indicator } = this.props;
		const query = indicator ? indicatorsByTagQuery : indicatorsQuery;
		const callback = ({ allindicatorsByTag, allIndicators }) => {
			const indicators = allindicatorsByTag
				? allindicatorsByTag
				: allIndicators;
			if (!this.state.loaded) {
				this.setState(
					(state) => ({ loaded: true }),
					() => {
						storeIndicators(indicators);
						//const first = _.get(allIndicators, "0.id", "");
						//handleChange("disease", first);
						handleLoad();
					}
				);
			}
		};

		return (
			<Query
				query={query}
				onCompleted={callback}
				variables={{ tag: indicator ? indicator._id : "" }}
				fetchPolicy="cache-and-network"
			>
				{({ loading, error, data }) => {
					const result =
						data && data.allindicatorsByTag
							? data.allindicatorsByTag
							: data && data.allIndicators
							? data.allIndicators
							: [];
					if (loading) {
						return <CircularProgress />;
					} else if (error) {
						return "Error cargando datos";
					} else {
						const sortedData = _.sortBy(result, ["name"]);
						const items = sortedData.map((disease) => {
							return (
								<MenuItem key={disease.id} value={disease.id}>
									{disease.name}
								</MenuItem>
							);
						});
						return (
							<TextField
								id="outlined-select-disease"
								select
								label="Indicador"
								value={value}
								onChange={(event) => {
									const diseaseId = event.target.value;
									this.handleChangeIndicator("disease", diseaseId);
								}}
								margin="normal"
								variant="outlined"
								fullWidth
								InputLabelProps={{
									shrink: true
								}}
							>
								{items}
							</TextField>
						);
					}
				}}
			</Query>
		);
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setAvailablePeriods
		},
		dispatch
	);

export default connect(null, mapDispatchToProps)(SelectDisease);



// WEBPACK FOOTER //
// ./src/components/filters/selectDisease.js